import React from 'react';
import { IconProps } from '.';

const SvgColoredShoppingBag = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FF71BA'
        d='M4.273 6.527A1.8 1.8 0 0 1 5.546 6h12.909a1.8 1.8 0 0 1 1.273.527L21.6 8.4H2.4l1.873-1.873Z'
      />
      <path
        fill='#FF99CE'
        fillRule='evenodd'
        d='M7.6 8.4V5.6c0-2.295 2.06-4 4.4-4 2.338 0 4.4 1.705 4.4 4v2.8h5.2l1.038 12.45a1.8 1.8 0 0 1-1.794 1.95H3.156a1.8 1.8 0 0 1-1.793-1.95L2.4 8.4h5.2Zm1.6-2.8c0-1.24 1.162-2.4 2.8-2.4 1.637 0 2.8 1.16 2.8 2.4v2.8H9.2V5.6Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgColoredShoppingBag;
